import * as React from 'react'
import styled from 'styled-typed'
import { History } from 'history'
import { ActionButton, ActionButtonA } from 'uiComponents/buttons'
import { TopButtonWrapper } from 'uiComponents/settingsContainer'
import Permission from 'admin/permissionRequired'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTag, faCalendarAlt } from '@fortawesome/pro-solid-svg-icons'
import ViewSelector from './viewSelector'
import SearchField from 'uiComponents/search/searchWithButton'
import { IconProp } from '@fortawesome/fontawesome'
import { useTranslation } from 'translations'

const BulkActionButton = styled(ActionButton)`
    width: 10em;
    font-size: 0.85em;
    padding: 0 1em;
    height: 2rem;
    font-weight: 500;
`

interface TopButtonProps {
    showBulkButtons: boolean
    loading: boolean
    showAdjustView?: boolean
    history: History
    accountSlug: string
    showBulkEditValidity: () => void
    showBulkEditPricing: () => void
    origin: string
}

export function ProductsTopButtons(props: TopButtonProps) {
    const { t } = useTranslation()
    const showAdjustView = props.showAdjustView ?? true

    return (
        <>
            <TopButtonWrapper style={{ justifyContent: 'space-between' }}>
                <div style={{ display: 'flex' }}>
                    {showAdjustView && (
                        <ViewSelector
                            setRadioSelection={(v: string) => {
                                v === 'categories'
                                    ? props.history.push(`/account/${props.accountSlug}/products/home/nested`)
                                    : props.history.push(`/account/${props.accountSlug}/products/home/flat`)
                            }}
                        />
                    )}
                    {location.pathname.indexOf('flat') > -1 && (
                        <SearchField
                            placeholder={t('products.topButtons.searchPlaceholder')}
                            style={{ width: '20em' }}
                            disabled={props.loading}
                        />
                    )}
                    {props.showBulkButtons ? (
                        <div>
                            <BulkActionButton size="medium" secondary onClick={props.showBulkEditValidity}>
                                <FontAwesomeIcon icon={faCalendarAlt as IconProp} style={{ marginRight: '.5em' }} />
                                {t('products.topButtons.editValidity')}
                            </BulkActionButton>
                            <BulkActionButton
                                size="medium"
                                secondary
                                style={{ marginRight: '1em', marginLeft: '1em' }}
                                onClick={props.showBulkEditPricing}
                            >
                                <FontAwesomeIcon icon={faTag as IconProp} style={{ marginRight: '.5em' }} />
                                {t('products.topButtons.editPricing')}
                            </BulkActionButton>
                        </div>
                    ) : (
                        <div />
                    )}
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Permission name="partner_admin" accountSlug={props.accountSlug}>
                        <ActionButtonA
                            id="newCategory"
                            size="medium"
                            href={`/account/${props.accountSlug}/products/crud/productList/new?from=${props.origin}`}
                            style={{ marginRight: '1em' }}
                            kind="action"
                            secondary
                        >
                            {t('products.topButtons.addCategory')}
                        </ActionButtonA>
                        <ActionButtonA
                            id="newProduct"
                            size="medium"
                            href={`/account/${props.accountSlug}/products/crud/new?from=${props.origin}`}
                            kind="action"
                        >
                            {t('products.topButtons.addProduct')}
                        </ActionButtonA>
                    </Permission>
                </div>
            </TopButtonWrapper>
        </>
    )
}

interface TopExceptioButtonProps {
    accountSlug: string
    for: 'pricing' | 'validity'
}
export function ExceptionsTopButtons(props: TopExceptioButtonProps) {
    const { t } = useTranslation()
    return (
        <TopButtonWrapper>
            <ActionButtonA
                id="newException"
                size="medium"
                href={`/account/${props.accountSlug}/products/${props.for}/exceptions/create`}
                kind="action"
            >
                {t('products.topButtons.addException')}
            </ActionButtonA>
        </TopButtonWrapper>
    )
}

type AddNewTopButtonSection = 'time_slots' | 'inventory' | 'option_groups'

function getAddNewTopButtonId(section: AddNewTopButtonSection) {
    switch (section) {
        case 'time_slots':
            return 'newTimeSlot'
        case 'inventory':
            return 'newInventory'
        case 'option_groups':
            return 'newOptionGroup'
        default:
            return ''
    }
}

function getAddNewTopButtonIHref(section: AddNewTopButtonSection) {
    switch (section) {
        case 'time_slots':
            return `time_slots/edit/new${location.search}`
        case 'inventory':
            return 'inventory/item/new'
        case 'option_groups':
            return 'option_groups/group_details/new'
        default:
            return ''
    }
}

interface AddNewTopButtonProps {
    accountSlug: string
    for: AddNewTopButtonSection
}
export function AddNewTopButton(props: AddNewTopButtonProps) {
    const { t } = useTranslation()
    return (
        <TopButtonWrapper>
            <div data-userpilot={props.for === 'time_slots' ? 'timeslots-list-add-new-button' : ''}>
                <ActionButtonA
                    id={getAddNewTopButtonId(props.for)}
                    href={`/account/${props.accountSlug}/products/${getAddNewTopButtonIHref(props.for)}`}
                    kind="action"
                >
                    {t('products.topButtons.addNew')}
                </ActionButtonA>
            </div>
        </TopButtonWrapper>
    )
}
